import { styled } from "@mui/material/styles";
import * as Sentry from "@sentry/react";
import useConfig from "hooks/useConfig";
import { Outlet } from "react-router-dom";
import UnknownError from "views/ui-elements/UnknownError";
import Footer from "./Footer";
import AppBar from "./Header";
const HeaderWrapper = styled("div")(({ theme }) => ({
  paddingTop: 0,
  overflowX: "hidden",
  overflowY: "clip",
  [theme.breakpoints.down("md")]: {
    paddingTop: 42,
  },
}));

const SecondWrapper = styled("div")(({ theme }) => ({
  paddingTop: 84,
  paddingBottom: 26,
  [theme.breakpoints.down("md")]: {
    paddingTop: 60,
  },
}));

const ErrorBoundary = () => {
  return (
    <PublicLayout>
      <UnknownError />
    </PublicLayout>
  );
};

const PublicLayout = () => {
  const { locale } = useConfig();
  const handleCaptchaOnChange = (e) => {
    console.info("captcha changed", e);
  };
  return (
    <>
      <Sentry.ErrorBoundary
        fallback={ErrorBoundary}
        showDialog
        dialogOptions={{
          lang: locale,
        }}
        beforeCapture={(scope) => {
          const cart = localStorage.getItem("eventpxl-cart");
          if (cart && cart !== "") {
            scope.setContext("cart", JSON.parse(cart));
          }
        }}
      >
        <HeaderWrapper id="public.home">
          <AppBar />
        </HeaderWrapper>
        <SecondWrapper>
          <Outlet />
        </SecondWrapper>
        <Footer />
      </Sentry.ErrorBoundary>
    </>
  );
};

export default PublicLayout;
